import {
  PriorPlatformEnum,
  SeoContinuityEnum,
  type PriorPlatform,
  type SeoContinuity,
} from '@flashpoint/site-dna';
import type { StepProps } from '../stepProps';
import { useLocalText } from '../useLocalText';

export function MigrationStep({ lead, queueField }: StepProps) {
  const m = lead.migration ?? { seoContinuity: 'Fresh Start' as SeoContinuity };

  const [priorUrl, setPriorUrl] = useLocalText(
    lead.id,
    m.priorUrl,
    'migration.priorUrl',
    queueField,
  );

  return (
    <div className="space-y-5">
      <div>
        <div className="mb-2 text-[11px] uppercase tracking-widest text-nm-muted">
          Prior platform
        </div>
        <div className="flex flex-wrap gap-2">
          {PriorPlatformEnum.options.map((opt) => {
            const selected = m.priorPlatform === opt;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => queueField('migration.priorPlatform', opt as PriorPlatform)}
                className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
                  selected
                    ? 'bg-flashpoint-spark text-nm-on-accent'
                    : 'border border-nm-border text-nm-ink hover:border-nm-accent'
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>

      <label className="block">
        <span className="text-[11px] uppercase tracking-widest text-nm-muted">Prior site URL</span>
        <input
          value={priorUrl}
          onChange={(e) => setPriorUrl(e.target.value)}
          placeholder="https://oldsite.example.com"
          className="mt-1 w-full rounded-md border border-nm-border bg-nm-bg px-3 py-2 text-sm text-nm-ink outline-none focus:border-nm-accent"
        />
      </label>

      <div>
        <div className="mb-2 text-[11px] uppercase tracking-widest text-nm-muted">
          SEO continuity
        </div>
        <div className="flex flex-col gap-2">
          {SeoContinuityEnum.options.map((opt) => {
            const selected = m.seoContinuity === opt;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => queueField('migration.seoContinuity', opt as SeoContinuity)}
                className={`rounded-lg border p-3 text-left text-sm transition ${
                  selected
                    ? 'border-flashpoint-ember bg-nm-surface text-nm-ink'
                    : 'border-nm-border bg-nm-moss/30 text-nm-ink hover:border-nm-muted'
                }`}
              >
                {opt}
                {opt === 'Preserve URLs' && (
                  <span className="mt-1 block text-[11px] text-nm-muted">
                    Same paths -&gt; rebuild without breaking SEO. Most common for redesigns.
                  </span>
                )}
                {opt === 'Redirect Map Required' && (
                  <span className="mt-1 block text-[11px] text-nm-muted">
                    Old paths change -&gt; you'll provide a from/to redirect map.
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
